import React from 'react';
import LeaveList from '../../../busi/saas/oa/leaveList';
import { getBooleanValue } from '../../../utils';
import DrawerWrapper from '@/components/drawerWrapper';
import { NavBar, Icon } from 'antd-mobile';
import { useHistory } from 'react-router';

function Leave(props){
  const history = useHistory();
  return (
    <DrawerWrapper>
      <div className={`app-layout${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
        <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => history.goBack()}>
            请休假审批
        </NavBar>
        <div className="app-tabs">
          <LeaveList/>
        </div>
      </div>
    </DrawerWrapper>
  );
}

export default Leave;
